export default "__VITE_ASSET__110ae710__"